<template>
    <teleport to="body">
        <Modal :close-button="false" @onClose="toggleModalHandler">
            <template #header>
                <h2>{{ message }}</h2>
            </template>
        </Modal>
    </teleport>
</template>
